import { useId, useState } from "react";
import { Chip, IconButton, Popover, Typography } from "@mui/material";
import { InfoOutlined, Smartphone } from "@mui/icons-material";

/** Touch and keyboard help: no long press or hover state to get stuck. */
export default function EntryHelp({
  text,
  phoneLabel,
}: {
  text: string;
  phoneLabel?: string;
}) {
  const id = useId();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const triggerProps = {
    "aria-label": text,
    "aria-expanded": Boolean(anchor),
    "aria-controls": anchor ? id : undefined,
    onClick: (event: React.MouseEvent<HTMLElement>) =>
      setAnchor(anchor ? null : event.currentTarget),
  };

  return (
    <>
      {phoneLabel ? (
        <Chip
          {...triggerProps}
          component="button"
          type="button"
          size="small"
          variant="outlined"
          icon={<Smartphone />}
          label={phoneLabel}
        />
      ) : (
        <IconButton
          {...triggerProps}
          size="small"
          sx={{ minWidth: 44, minHeight: 44 }}
        >
          <InfoOutlined fontSize="small" />
        </IconButton>
      )}
      <Popover
        id={id}
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { sx: { p: 1.5, maxWidth: 300, borderRadius: 2 } },
        }}
      >
        <Typography variant="body2">{text}</Typography>
      </Popover>
    </>
  );
}
